import { AsyncPipe, NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MatFormField } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import {
  ElderHeaderComponent,
  ElderPaneActionsComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneSubtitleComponent,
  ElderPaneTitleComponent,
  ElderSelectComponent,
  ElderSelectValueDirective,
  ElderSinglePaneWrapperComponent,
  ElderThemeDirective,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { ActionSelectDirective } from '../../../actions/action-select/action-select.directive'
import { OperationSegmentSpec } from '../../process-plan'

@Component({
  selector: 'app-operation-segment-spec-detail',
  templateUrl: './operation-segment-spec-detail.component.html',
  styleUrls: ['./operation-segment-spec-detail.component.scss'],
  imports: [
    ElderSinglePaneWrapperComponent,
    ElderPaneHeaderComponent,
    ElderPaneTitleComponent,
    ElderPaneActionsComponent,
    ElderPaneContentComponent,
    ElderPaneSubtitleComponent,
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatIcon,
    NgTemplateOutlet,
    FormsModule,
    MatFormField,
    ElderSelectComponent,
    ActionSelectDirective,
    ElderSelectValueDirective,
    ElderHeaderComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class OperationSegmentSpecDetailComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _operationSegmentSpec$: BehaviorSubject<OperationSegmentSpec> =
    new BehaviorSubject(null)

  private _creationMode: boolean

  @Input()
  public embedded = false

  @Output()
  public close: EventEmitter<Event> = new EventEmitter<Event>()

  @Output()
  public save: EventEmitter<Event> = new EventEmitter<Event>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    if (!this.operationSegmentSpec) {
      this.operationSegmentSpec = this.initNew()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Getter / Setters                                                        *
   *                                                                         *
   **************************************************************************/

  public get operationSegmentSpec$(): Observable<OperationSegmentSpec> {
    return this._operationSegmentSpec$.asObservable()
  }

  public get operationSegmentSpec(): OperationSegmentSpec {
    return this._operationSegmentSpec$.getValue()
  }

  @Input()
  public set operationSegmentSpec(spec: OperationSegmentSpec) {
    if (spec) {
      this._creationMode = !spec.action
      this._operationSegmentSpec$.next(spec)
    }
  }

  public get creationMode(): boolean {
    return this._creationMode
  }

  public get deletionEnabled(): boolean {
    return !this.creationMode
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onSave(event: Event): void {
    this.emitSave(event)
  }

  public onClose(event: Event): void {
    this.emitClose(event)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitSave(event?: Event): void {
    this.save.emit(event)
  }

  private emitClose(event?: Event): void {
    this.close.emit(event)
  }

  private initNew(): OperationSegmentSpec {
    return new OperationSegmentSpec()
  }
}
